export const actionTypesByKey = {
  drop: 'drop',
  pick: 'pick',
};

export const actionTypes = Object.values(actionTypesByKey);
